import { z } from "zod";
import { createProgramaSchema } from "./createProgramaSchema";

export const editProgramaSchema = createProgramaSchema.partial().extend({
  id: z.number(),
  isActivo: z.boolean().optional(),
});

export type EditProgramaInput = z.infer<typeof editProgramaSchema>;
